import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const skip = /auth\/(login|refresh|logout)/.test(cfg.url || "");
    if (err.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
}
